module.exports = __webpack_public_path__ + "static/media/nachoChips.47e84b8f.png";